export default __webpack_public_path__ + "907db7e1949629e69acea6e808ab7254.png";